import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useSelector } from 'react-redux';
import { getWhichOAuthEndpointFailed } from '../store/app/selectors';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Step } from 'signup-constants/Step';
import { jsx as _jsx } from "react/jsx-runtime";
export const OAuthVerificationFailureText = ({
  oAuth
}) => {
  const failedOAuth = useSelector(getWhichOAuthEndpointFailed);
  const messageKey = `views.${Step.LandingPage}.oAuthFailHelperText.${oAuth}`;
  if (oAuth !== failedOAuth || !isValidI18nKey(messageKey)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    marginBlockStart: "200",
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(Text, {
        as: "div",
        color: "text-core-subtle",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: messageKey
        })
      })
    })
  });
};